export const email_regex = /^([^ ()<>@,;:"\[\]ç%&A-Z\u00C0-\u00FF])+@([a-z]*\.(?!$))+([a-z]*$)/g;

export const regexpGSM338 = new RegExp(`^[A-Za-z0-9 \r\n@£$¥èéùìòÇØøÅå\u0394_\u03A6\u0393\u039B\u03A9\u03A0\u03A8\u03A3\u0398\u039EÆæßÉ!"#$%&amp;'()*+,\-./:;&lt;=&gt;?¡ÄÖÑÜ§¿äöñüà^{}\\\[~\]|\u20AC]*$`);